import { render, staticRenderFns } from "./OrderContainerChapter.vue?vue&type=template&id=dd04bd60&scoped=true"
import script from "./OrderContainerChapter.vue?vue&type=script&lang=js"
export * from "./OrderContainerChapter.vue?vue&type=script&lang=js"
import style0 from "./OrderContainerChapter.vue?vue&type=style&index=0&id=dd04bd60&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd04bd60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd04bd60')) {
      api.createRecord('dd04bd60', component.options)
    } else {
      api.reload('dd04bd60', component.options)
    }
    module.hot.accept("./OrderContainerChapter.vue?vue&type=template&id=dd04bd60&scoped=true", function () {
      api.rerender('dd04bd60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/ContainerOrders/OrderContainerChapter.vue"
export default component.exports